// ── 마커 표시 미리보기 (2026-10-24) — 지도와 **같은 함수**(meetingMarkerHtml)로 그린다 ──
// 이 테넌트 카테고리 하나에 보기 마커 하나(사용자: "지금 카테고리 2개니까 2개만 뜨면 좋겠어").
//   시간 모양 차이가 보이게 보기 시간을 '14:00'·'4시'(→ 16:00)·'2시이후'(그대로) … 로 돌려 쓴다.
import React from 'react';
import { meetingMarkerHtml } from '../../../components/meetingmap/MarkerIcons';

const SAMPLES = [
  { company_name: '새벽서점 강남점', visit_time: '14:00' },
  { company_name: '정오식당', visit_time: '4시' },
  { company_name: '저녁상회', visit_time: '2시이후' },
  { company_name: '한낮카페', visit_time: '오전 11시' },
];

export function MarkerPreview({ config, categories }) {
  const cats = categories.length ? categories : [''];
  const items = cats.map((cat, i) => ({ ...SAMPLES[i % SAMPLES.length], id: i + 1, ticket_type_category: cat }));
  return (
    <div className="flex flex-col gap-2">
      <div className="text-[12px] font-bold text-[var(--text)]">
        미리보기 <span className="font-normal text-[var(--text-muted)]">실제 지도 마커와 같은 모양</span>
      </div>
      {/* 지도 타일처럼 밝은 바탕 — 다크 모드에서도 실제 지도처럼 밝게 둔다 */}
      <div className="flex flex-col items-center gap-6 rounded-xl border border-[var(--border)] px-4 pb-6 pt-10"
        style={{ background: 'repeating-linear-gradient(45deg,#eef2e6,#eef2e6 14px,#e6ebdc 14px,#e6ebdc 28px)' }}>
        {items.map((it) => (
          <div key={it.id} className="flex flex-col items-center gap-1">
            {/* 마커 글자는 escapeHtml 을 거친다(MarkerIcons) — 지도 아이콘과 같은 HTML */}
            <div dangerouslySetInnerHTML={{ __html: meetingMarkerHtml(it, false, config) }} />
            <span className="text-[10.5px] text-slate-500">{it.ticket_type_category || '카테고리 없음'}</span>
          </div>
        ))}
      </div>
      <div className="text-[10.5px] leading-relaxed text-[var(--text-muted)]">
        저장하면 이 테넌트의 모든 미팅지도(관리·회사별·통합·직원 미팅지도)가 같이 바뀝니다.
      </div>
    </div>
  );
}
